import { initCookie } from "./main/cookie";
import { initCountUp } from './main/countUp';
// import { initSelectStyled } from "./main/select";
import { initAdminMenu } from "./adminMenu";
import { initSteps } from "./main/steps";

window.initializeCmsContent = function() {
	initCountUp();
	initSteps();
}

window.initializeScript = function() {
	// console.log('initializeScript');
	initCookie();
	// initSelectStyled();
	initAdminMenu();
};

document.addEventListener("DOMContentLoaded", () => {
	// console.log('DOMContentLoaded');
	window.initializeScript();
});
